/**
 * Created by Ivo Mehide <ivo@degeetia.ee> on 19.06.17.
 */

import * as formatters from "./Formatter";

const DEFAULT_FORMATTER = ["Type"];
const ENUM_FORMATTER = ["Enum"];

class SchemaValueFormatter {
    /**
     *
     * @param {Schema} schema
     */
    constructor(schema) {
        this.schema = schema;

        let formatterSpec = this.schema.getSchemaElement("valueFormatter");
        if (!formatterSpec) {
            if (this.schema.getEnum()) formatterSpec = ENUM_FORMATTER;
            else formatterSpec = DEFAULT_FORMATTER;
        }

        let FormatterClass = formatters[formatterSpec[0] + "Formatter"];
        let params = formatterSpec.slice(1);
        this.formatter = null;
        if (FormatterClass) {
            this.formatter = new FormatterClass(this.schema, params);
        }
    }

    /**
     * Formaadib väärtuse vastavalt JSON Schema's toodud infole
     * @param {*} value
     * @returns {string}
     */
    format(value) {
        if (!this.formatter) {
            if (value == null) return "";
            return value.toString();
        }
        return this.formatter.format(value);
    }
}

export default SchemaValueFormatter;
